import moment from 'moment';

function hasExpired(meta) {
    if (!meta.expiresAt) {
        return false;
    }

    return moment(meta.expiresAt).isBefore(moment());
}

export {
    hasExpired,
};
